module.exports = __webpack_public_path__ + "img/logo_usdt.d7befda9.png";